package org.hs_soft.runmynesto.pages.components.dialog.dialog

import androidx.compose.runtime.Composable
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.window
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.domain.util.openLocalForSelectingFile
import org.hs_soft.runmynesto.pages.components.CustomTextArea
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.UploadImage
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.HTMLImageElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.url.URL

@Composable
fun ImageAIDialog(
    windowSizeMode: WindowSizeModeEnum,
    imgGeneratedUrl:String?,
    description:String,
    submitGeneratedImgLoading:Boolean,
    generateImgLoading:Boolean,
    id:String,
    isSubmitClickable: Boolean,
    onBackgroundClick: () -> Unit,
    onDescriptionInputChange: (String) -> Unit,
    onCancelClick: () -> Unit,
    onSubmitClick: (String,String?) -> Unit,
    onGenerateImgClick: (String) -> Unit,
    onSelectImg:(String)->Unit,
)
{
    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onBackgroundClick()
            }
    ){

        Column(
            modifier = Modifier
                .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                }
                .align(Alignment.Center)
                .width( Dimen.imageAIDialogWidth)
                .height(
                   Dimen.imageAIDialogHeight
                )
                .thenIf(
                    windowSizeMode== WindowSizeModeEnum.PHONE,
                    Modifier.fillMaxHeight()
                        .fillMaxWidth()
                )
                .generalDialogSetting(),
            horizontalAlignment = Alignment.CenterHorizontally
        ){

            DialogTitle(
                title = Strings.current().newImage,
                showCloseIcon = true,
                showSeparator = false,
                onCloseClick = {
                    onCancelClick()
                }
            )

            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(Dimen.extraLargePadding)

            )
            {
                if (windowSizeMode== WindowSizeModeEnum.PHONE){
                    Column(
                        modifier = VerticalScrollBehavior.toModifier()
                            .overflow(Overflow.Auto)
                            .fillMaxSize(),
                    )
                    {
                        UploadManually(
                            imgGeneratedUrl=imgGeneratedUrl,
                            onSelectImg={
                                onSelectImg(it)
                            },
                        )

                        GenerateUsingAI(
                            description=description,
                            generateImgLoading=generateImgLoading,
                            onDescriptionInputChange={
                                onDescriptionInputChange(it)
                            },
                            onGenerateImgClick={
                                onGenerateImgClick(it)
                            }
                        )

                    }
                }else{
                    Row(
                        modifier = Modifier
                            .fillMaxSize(),
                    )
                    {
                        UploadManually(
                            imgGeneratedUrl=imgGeneratedUrl,
                            onSelectImg={
                                onSelectImg(it)
                            },
                        )

                        Spacer()

                        GenerateUsingAI(
                            description=description,
                            generateImgLoading=generateImgLoading,
                            onDescriptionInputChange={
                                onDescriptionInputChange(it)
                            },
                            onGenerateImgClick={
                                onGenerateImgClick(it)
                            }
                        )

                    }
                }


                Spacer()




                Row(
                    modifier = Modifier
                        .fillMaxWidth(),
                    horizontalArrangement = Arrangement.End,
                )
                {

                    CustomButton(
                        modifier = Modifier
                            .margin(
                                right = Dimen.normalPadding
                            ),
                        title = Strings.current().cancel,
                        buttonType = ButtonTypes.TEXT,
                        onButtonClick ={
                            onCancelClick()
                        },

                    )

                    CustomButton(
                        isClickable =isSubmitClickable,
                        loading = submitGeneratedImgLoading,
                        title = Strings.current().save,
                        buttonType = ButtonTypes.CONTAINED,
                        onButtonClick ={
                            onSubmitClick(
                                id,
                                imgGeneratedUrl,
                            )
                        },
                    )



                }
            }






        }



    }



}

@Composable
private fun GenerateUsingAI(
    description: String,
    generateImgLoading: Boolean,
    onDescriptionInputChange: (String) -> Unit,
    onGenerateImgClick: (String) -> Unit
) {
    Column()
    {
        MediumContentTitle(
            title = Strings.current().generateUsingAI,
            marginBottom = Dimen.extraLargePadding,
        )


        GenerateImg(
            description = description,
            generateImgLoading = generateImgLoading,
            onDescriptionInputChange = {
                onDescriptionInputChange(it)
            },
            onGenerateImgClick = {
                onGenerateImgClick(it)
            },
        )


    }
}

@Composable
private fun UploadManually(
    onSelectImg: (String) -> Unit,
    imgGeneratedUrl: String?
) {
    Column(
        modifier = Modifier.fillMaxWidth()
    )
    {
        MediumContentTitle(
            title = Strings.current().uploadManually,
            marginBottom = Dimen.extraLargePadding,
        )

        SetImgFromLocal(
            getImg = { url: String ->
                onSelectImg(url)
            }
        )

        UploadImage(
            modifier = Modifier
                .margin(top = Dimen.normalPadding),
            width = Dimen.uploadImgSize,
            height = Dimen.uploadImgSize,
            imgUrl = imgGeneratedUrl,
            onImgContentClick = {
                openLocalForSelectingFile()
            },
        )

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .margin(top = Dimen.semiMediumPadding),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                text = Strings.current().uploadImgInfoSize,
                modifier = Modifier
                    .textAlign(TextAlign.Center)
                    .fontSize(FontSizes.mediumFontSize)
                    .color(Theme.TextSecondary.rgb)
                    .fontFamily(FontFamily.Jakarta)
            )

            SpanText(
                text = Strings.current().uploadImgInfoType,
                modifier = Modifier
                    .textAlign(TextAlign.Center)
                    .fontSize(FontSizes.mediumFontSize)
                    .color(Theme.TextSecondary.rgb)
                    .fontFamily(FontFamily.Jakarta)
            )
        }


    }
}


@Composable
fun SetImgFromLocal(
    id:String="",
    getImg:(String)->Unit,
)
{
    Input(
        type = InputType.File,
        attrs = {
            style {
                property("display", "none")
            }
            id(id)
            onChange { event ->

                val inputElement = event.target as HTMLInputElement
                val file = inputElement.files?.item(0)
                file?.let { originalFile ->
                    // Create an image element to load the file
                    val img = window.document.createElement("img")
                            as HTMLImageElement
                    img.onload = {
                        val canvas = window.document.createElement("canvas")
                                as HTMLCanvasElement
                        val ctx = canvas.getContext("2d") as CanvasRenderingContext2D

                        // Set canvas size to the image size
                        canvas.width = img.width
                        canvas.height = img.height

                        // Draw image on canvas
                        ctx.drawImage(img, 0.0, 0.0)

                        // Function to adjust quality to reduce size to under 150 KB
                        fun compressAndCheckSize(quality: Double): String? {
                            val dataUrl = canvas.toDataURL("image/jpeg", quality)
                            val base64Data = dataUrl.split(",")[1]
                            val byteSize = (base64Data.length * (3 / 4)) -
                                    (if (base64Data.endsWith("==")) 2
                                    else if (base64Data.endsWith("=")) 1 else 0)

                            if (byteSize <= Constants.maxReceiveTemplateImgSize * 1024) {
                                return dataUrl
                            } else if (quality > 0.1) {
                                return compressAndCheckSize(quality - 0.1)
                            }
                            return null
                        }

                        // Start compression with high quality
                        val compressedDataDataUrl = compressAndCheckSize(0.9)

                        if (compressedDataDataUrl != null) {
                            getImg(
                                compressedDataDataUrl,
//                                originalFile.name,
                            )
                        } else {
                            console.error("Unable to compress image to desired size")
                        }
                    }

                    img.src = URL.createObjectURL(originalFile)
                }
            }
        }
    )
}

@Composable
private fun GenerateImg(
    description: String,
    generateImgLoading:Boolean,
    onDescriptionInputChange: (String) -> Unit,
    onGenerateImgClick: (String) -> Unit,
) {

    Column(
        modifier = Modifier
            .height(
                (Dimen.uploadImgSize.value.toInt()+
                        Dimen.normalPadding.value.toInt())
                    .px
            )
    )
    {
        CustomTextArea(
            modifier = Modifier ,
            value = description,
            label = Strings.current().prompt,
            width = Dimen.promptImageAIDialogWidth,
            height =Dimen.promptImageAIDialogHeight,
            maxHeight = Dimen.promptImageAIDialogHeight,
            onFocusOut ={

            }
        ) {
            onDescriptionInputChange(it)
        }

        Spacer()

        Box(
            modifier = Modifier
                .fillMaxWidth()
        ) {

            CustomButton(
                modifier = Modifier
                    .backgroundColor(Theme.White.rgb)
                    .align(Alignment.CenterStart),
                isClickable =description.isNotEmpty(),
                icon = Res.PathIcon.star ,
                iconTint = Theme.PrimaryMain.hex,
                loading = generateImgLoading,
                iconSize =Dimen.normalIconSize ,
                title = Strings.current().generate,
                buttonType =if (generateImgLoading)
                    ButtonTypes.CONTAINED else ButtonTypes.OUTLINED,
                onButtonClick = {
                    onGenerateImgClick(description)
                }
            )
        }
    }

}
